import { formatToCommaWithLang, preciseAdd, preciseMinus, soundManager, toCommaOptions, usePlayerStore } from '@slot-nx/core'
import { numberAnimation } from '../../../components/util/numberAnimationUtil'
import { BitmapText, Container, Text } from 'pixi.js'
import gsap from 'gsap'
import { useGameStore } from '../../game/store/GameStore'
import { sleep } from '../../game/util/gameUtil'
import { SweetBombSoundType } from '../../soundManager/enum/soundType'

class WinBarService {
  public tumbleWinBar: Container
  public totalWinBarRef: Container
  public balanceBar: Container
  private prevTumblePayout: number
  private nextTumblePayout: number
  private prevWinPayout: number
  private nextWinPayout: number
  private prevDisplayBalance: number
  private nextDisplayBalance: number

  public async updateTumbleWinBar(hasAnimation: boolean) {
    const TumbleWinText = this.tumbleWinBar.getChildByName('TumbleWinText') as Text
    if (this.tumbleWinBar.alpha !== 1) {
      this.fadeIn(this.tumbleWinBar)
    }
    if (hasAnimation) {
      soundManager.play(SweetBombSoundType.MultiTumbleAdd)
      numberAnimation(this.prevTumblePayout, this.nextTumblePayout, 0.4, TumbleWinText)
    }
    else {
      soundManager.play(SweetBombSoundType.MultiTumbleAdd2)
      TumbleWinText.text = formatToCommaWithLang(this.nextTumblePayout, navigator.language, toCommaOptions.forceTwoDecimalPlaces)
    }
  }

  public async updateTotalWinBar(hasAnimation: boolean) {
    const totalWinPayout = this.totalWinBarRef.getChildByName('totalWinPayout') as BitmapText
    this.fadeIn(this.totalWinBarRef)
    if (hasAnimation) {
      numberAnimation(this.prevWinPayout, this.nextWinPayout, 0.4, totalWinPayout)
    }
    else {
      totalWinPayout.text = formatToCommaWithLang(this.nextWinPayout, navigator.language, toCommaOptions.forceTwoDecimalPlaces)
    }
  }

  public async updateBalance() {
    // const balanceText = this.balanceBar.getChildByName('amount') as Text
    // numberAnimation(this.prevDisplayBalance, this.nextDisplayBalance, 0.4, balanceText)
    // 1xbet requirement
  }

  public updateFinalBalance() {
    // const finalBalance = useGameStore.getState().finalBalance
    // usePlayerStore.setState({ balance: finalBalance })
    // 1xbet requirement
  }

  public closeTumbleWinBar() {
    if (this.tumbleWinBar) {
      this.fadeOut(this.tumbleWinBar)
    }
  }

  public closeTotalWinBar() {
    if (this.totalWinBarRef) {
      this.fadeOut(this.totalWinBarRef)
    }
  }

  private fadeIn(node: Container) {
    const animate = gsap.timeline({
      onComplete: () => {
        animate.kill()
      },
    })
    animate.to(node, {
      alpha: 1,
      duration: 0.2,
    })
  }

  private fadeOut(node: Container) {
    const animate = gsap.timeline({
      onComplete: () => {
        animate.kill()
      },
    })
    animate.to(node, {
      alpha: 0,
      duration: 0.2,
    })
  }

  private setOriginPayout() {
    const gameStore = useGameStore.getState()
    const balance = usePlayerStore.getState().balance
    const { currentOriginPayout, spinAccumulatedPayout, freeGameAccumulatedPayout, isFreeGame } = gameStore

    this.prevTumblePayout = spinAccumulatedPayout
    this.nextTumblePayout = preciseAdd(spinAccumulatedPayout, currentOriginPayout)

    this.prevWinPayout = isFreeGame ? freeGameAccumulatedPayout : spinAccumulatedPayout
    this.nextWinPayout = preciseAdd(isFreeGame ? freeGameAccumulatedPayout : spinAccumulatedPayout, currentOriginPayout)

    this.prevDisplayBalance = balance
    this.nextDisplayBalance = preciseAdd(balance, currentOriginPayout)
  }

  private setMultipliedPayout() {
    const gameStore = useGameStore.getState()
    const { currentOriginPayout, currentPayout } = gameStore
    const diff = preciseMinus(currentPayout, currentOriginPayout)

    this.prevTumblePayout = this.nextTumblePayout
    this.nextTumblePayout = preciseAdd(this.nextTumblePayout, diff)

    this.prevWinPayout = this.nextWinPayout
    this.nextWinPayout = preciseAdd(this.nextWinPayout, diff)

    this.prevDisplayBalance = this.nextDisplayBalance
    this.nextDisplayBalance = preciseAdd(this.nextDisplayBalance, diff)
    useGameStore.setState({
      spinAccumulatedPayout: this.nextTumblePayout,
      freeGameAccumulatedPayout: this.nextWinPayout,
    })
    // usePlayerStore.setState({ balance: this.nextDisplayBalance })
    // 1xbet requirement
  }

  public updateOriginalPayout() {
    const isThisSpinInSpeedMode = useGameStore.getState().isThisSpinInSpeedMode
    this.setOriginPayout()
    if (!isThisSpinInSpeedMode) {
      this.updateTumbleWinBar(false)
      this.updateTotalWinBar(false)
      this.updateBalance()
    }
  }

  public async updateMultipliedPayout() {
    this.setMultipliedPayout()
    this.updateTumbleWinBar(true)
    this.updateTotalWinBar(true)
    this.updateBalance()
    await sleep(400)
  }
}
export const winBarService = new WinBarService()
